import { put, takeEvery } from "redux-saga/effects";
import { PopularRanking, Statistics } from "../../models/statistics";
import {
    GetPopularRankingStarted,
    GetPopularRankingCompleted,
    GetStatisticsCompleted,
    GetStatisticsStarted,
    GetDocumentStatisticsCompleted,
    GetDocumentPopularRanking,
    GetDocumentStatistics,
    GetDocumentPopularRankingCompleted,
    SaveDocumentStatistics,
    SaveDocumentStatisticsCompleted,
} from "../actions/StatisticsActions";
import StatisticApi from "../apis/StatisticsApi";
import StatisticEvent from "../events/StatisticsEvent";

//統計情報取得
function* GetStatisticWorker({ startDate, endDate }: ReturnType<typeof GetStatisticsStarted>) {
    const statistics: Statistics = yield StatisticApi.getStatistics(startDate, endDate);
    yield put(GetStatisticsCompleted(statistics));
}

//ランキング情報取得
function* GetPopularRankingWorker({
    startDate,
    endDate,
}: ReturnType<typeof GetPopularRankingStarted>) {
    const popularRanking: PopularRanking = yield StatisticApi.getPoputlarRanking(
        startDate,
        endDate
    );
    yield put(GetPopularRankingCompleted(popularRanking));
}

//統計情報取得
function* GetDocumentStatisticWorker({
    startDate,
    endDate,
}: ReturnType<typeof GetDocumentStatistics>) {
    const statistics: Statistics = yield StatisticApi.getDocumentStatistics(startDate, endDate);
    yield put(GetDocumentStatisticsCompleted(statistics));
}

//ランキング情報取得
function* GetDocumentPopularRankingWorker({
    startDate,
    endDate,
}: ReturnType<typeof GetDocumentPopularRanking>) {
    const popularRanking: PopularRanking = yield StatisticApi.getDocumentPoputlarRanking(
        startDate,
        endDate
    );
    yield put(GetDocumentPopularRankingCompleted(popularRanking));
}

//ランキング情報取得
function* SaveDocumentStatisticsWorker({
    userId,
    documentId,
    documentTag,
    documentTitle,
    imageUrl,
}: ReturnType<typeof SaveDocumentStatistics>) {
    yield StatisticApi.saveDocumentStatistics(
        userId,
        documentId,
        documentTag,
        documentTitle,
        imageUrl
    );
    yield put(SaveDocumentStatisticsCompleted());
}
export default function* StatisticSaga() {
    yield takeEvery(StatisticEvent.GetStatisticsStarted, GetStatisticWorker);
    yield takeEvery(StatisticEvent.GetPopularRankingStarted, GetPopularRankingWorker);
    yield takeEvery(StatisticEvent.GetDocumentStatisticsStarted, GetDocumentStatisticWorker);
    yield takeEvery(
        StatisticEvent.GetDocumentPopularRankingStarted,
        GetDocumentPopularRankingWorker
    );
    yield takeEvery(StatisticEvent.SaveDocumentStatisticsStarted, SaveDocumentStatisticsWorker);
}
